<template>
    <div class="m-2 border-2 rounded-md bg-primary-50 border-primary-400 text-primary-800" :class="[widthClasses]">
        <!-- Header -->
        <div
            v-if="$slots.title || $slots.icons"
            class="flex flex-wrap items-center justify-between px-4 py-2 bg-primary-300 bold"
        >
            <!-- title -->
            <p v-if="$slots.title" class="font-bold text-primary-900">
                <slot name="title" />
            </p>

            <!-- icons -->
            <div
                v-if="$slots.icons"
                class="flex cursor-pointer hover:text-primary-900 disabled:text-primary-500 disabled:cursor-not-allowed gap-x-2"
            >
                <slot name="icons" />
            </div>
        </div>

        <!-- Body  -->
        <div v-if="$slots.body" class="px-4 py-0 my-2">
            <slot name="body" />
        </div>

        <!-- footer -->
        <div
            v-if="$slots.footer"
            class="flex flex-wrap items-center justify-between p-2 italic border-t-2 border-primary-400 text-xs"
        >
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'CardHydro',
    props: {
        styling: {
            type: String,
            required: false,
        },
    },
    setup(props) {
        const widthClasses = computed(() => {
            return props.styling ? props.styling : '';
        });

        return { widthClasses };
    },
});
</script>
